function callbackDone(response) {
    if (response?.success) {
        ESR.Popup.success({
            html: response?.data?.message ?? 'No success message',
            confirmButtonText: ESR.lang.close,
            confirmButtonUrl: 'reload'
        });
    } else {
        console.log(response)
        ESR.Popup.error({text: response?.data?.message ?? 'No error message'});
    }
}

function callbackFail(jqXHR, textStatus, errorThrown) {
    ESR.Popup.error({text: errorThrown});
}

export function ajaxRequest({action, data, fnBefore, fnDone, fnFail}) {
    if (fnBefore === undefined) fnBefore = () => {
    }
    if (fnDone === undefined) fnDone = callbackDone;
    if (fnFail === undefined) fnFail = callbackFail;

    return $.ajax({
        type: "POST",
        url: ESR.ajaxurl,
        data: {action, security: ESR.nonce, ...data},
        beforeSend: fnBefore,
    }).done(fnDone).fail(fnFail);
}

export function ajaxProjectUpdate({title, manager_id, post_id, status}) {
    const done = ({success, data}) => {
        if (success) {
            let popupArgs = {
                text: data.message,
                confirmButtonText: ESR.lang.close,
                showConfirmButton: true,
                confirmButtonUrl: 'reload',
            }

            if (!post_id) {
                popupArgs = {
                    text: data?.message,
                    confirmButtonText: ESR.lang.addWorks,
                    cancelButtonText: ESR.lang.leter,
                    confirmButtonUrl: data?.permalink_add,
                    cancelButtonUrl: 'reload',
                    closeButtonUrl: 'reload',
                    showCloseButton: true,
                }
            }

            ESR.Popup.success(popupArgs);
        } else {
            Swal.showValidationMessage(data.message);
            return;
        }
    }

    return ajaxRequest({
        action: "esr_update_project",
        data: {title, manager_id, post_id, status},
        fnDone: done
    });
}


export function ajaxWorkAdd(data, elButton) {
    const fnBefore = () => {
        elButton.addClass('btn-loading');
    }
    const fnDone = ({success, data}) => {

        if (data?.warnings && data.warnings.length) {
            console.log('Warning')
            console.log(data)
            elButton.removeClass('btn-loading');
            return;
        }

        if (success) {

            ESR.Popup.success({
                text: `Lucrările au fost adăugate cu succes.`,
                confirmButtonText: "Vezi obiectivul",
                cancelButtonText: "Adaugă Lucrări",
                confirmButtonUrl: data.project_link,
                cancelButtonUrl: 'reload',
                closeButtonUrl: 'reload'
            })

            elButton.removeClass('btn-loading');
            return;
        } else {
            ESR.Popup.error({text: data.message});
        }
    }

    return ajaxRequest({
        action: 'esr_add_works',
        data,
        fnBefore,
        fnDone
    });
}

